/** @format */

import {CommonChartData} from 'components/charts/multiline-chart/model/charts';

import NoteButton from '../components/notes/button';
import {ScatterDataOptions} from './memory-handler/types';

const getScatterPointDataNotes = ({
  buttonData,
  refetchNotes,
  pointName,
  date,
}: ScatterDataOptions): CommonChartData => {
  const primary = buttonData?.value ?? 0;

  return {
    name: pointName,
    primary,
    scatterOptions: {
      IconComponent: <NoteButton buttonData={buttonData} date={date} refetchNotes={refetchNotes} />,
    },
  };
};

export {getScatterPointDataNotes};
